// extracted by mini-css-extract-plugin
export default {"postContent":"MZfN"};